
import XHeader from 'vux/src/components/x-header/index.vue'
import Actionsheet from 'vux/src/components/actionsheet/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'

import { mapActions, mapState } from 'vuex'
export default {
name: 'user',
props: [],
components: {
XHeader,
Actionsheet
},
directives: {
TransferDom
},
data () {
return {
title: this.$route.meta.title,
innerWidth: (document.documentElement.clientHeight - 48) * 828 / 1355,
imgsrc: '',
imgErrorUrl: 'this.src="' + require('@/assets/sass/images/default.png') + '"'
}
},
computed: {
...mapState({
token: state => state.token
})
},
created () {},
mounted () {
},
methods: {
...mapActions(['LogoutAction']),
back () {
setTimeout(() => {
this.$router.back(-1)
}, 300)
},
Login () {
this.$router.push({
name: 'login'
})
}
}
}



// WEBPACK FOOTER //
// ./src/yingxin/tskjxy/views/user/userItem/fullOffer.vue